<script setup lang="ts">
import {computed, ref} from "vue";
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import ChatPresenter from "@/utils/presenters/ChatPresenter.ts";
import ChatUtils from "@/utils/common/ChatUtils.ts";

const props = defineProps<{
  presenter: ChatPresenter;
  users: any[];
}>();

const emit = defineEmits<{
  (e: 'back'): void;
  (e: 'createNewGroup'): void;
}>();

const searchValue = ref();

const filteredUsers = computed(() =>
  ChatUtils.filterUsers(props.users ?? [], searchValue.value ?? '')
);
</script>

<template>
  <div class="tw-flex tw-flex-col tw-min-h-0 tw-grow tw-w-full">
    <div class="tw-flex-none tw-shrink-0 tw-w-full">
      <q-list class="tw-w-full">
        <q-item class="tw-py-0">
          <div class="tw-flex tw-flex-row tw-self-center tw-w-full tw-gap-1.5">
            <q-btn unelevated no-caps dense
                   @click="emit('back')"
                   :title="Translator.translateId('back')"
                   class="tw-p-1 tw-rounded-md tw-text-namaFontColor-input-gray dark:tw-text-namaFontColor-input-dark tw-w-fit">
              <NamaIcon default-icon="arrow_back" class="tw-size-5 !tw-text-xl" :class="[Translator.isArabic()?'tw-rotate-180':'']"/>
            </q-btn>
            <div class="tw-w-full tw-font-semibold">
              <span v-text="Translator.translateId('startNewChat')"/>
            </div>
          </div>
        </q-item>
        <q-item class="tw-py-0">
          <div class="tw-relative tw-leading-tight tw-w-full tw-h-full">
                <span class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-pl-3">
                  <NamaIcon defaultIcon="search"/>
                </span>
            <input type="text" :placeholder="Translator.translateId('search')" v-model="searchValue"
                   class="tw-border-none tw-bg-namaBackground-deep-light dark:tw-bg-namaBackground-deep-dark
                       dark:hover:tw-bg-namaBackground-bright-dark hover:tw-bg-namaBackground-bright-light
                       dark:focus:tw-bg-namaBackground-bright-dark focus:tw-bg-namaBackground-bright-light
                        tw-shadow tw-appearance-none tw-rounded-md tw-w-full tw-py-2 tw-pl-12  tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark
                  focus:tw-ring-0 focus:tw-outline-none focus:tw-shadow-outline dark:tw-placeholder-gray-300" autocomplete="off"
            />
          </div>
        </q-item>
      </q-list>
    </div>
    <div class="tw-grow tw-overflow-y-auto tw-w-full tw-min-h-0 tw-pb-3">
      <q-item v-ripple clickable @click="emit('createNewGroup')" :title="Translator.translateId('createNewGroup')">
        <q-item-section avatar>
          <NamaIcon default-icon="group_add" class="tw-size-5"/>
        </q-item-section>
        <q-item-section v-text="Translator.translateId('createNewGroup')"/>
      </q-item>
      <template v-for="(user, index) in filteredUsers" :key="index">
        <q-item clickable :active="true" @click="presenter.createConversationAndOpen('Direct', [user])">
          <q-item-section avatar>
            <q-avatar color="primary">
              <img :src="LoginUtils.getUserImageSrc(user.id ?? '', false)" alt="">
            </q-avatar>
          </q-item-section>
          <q-item-section v-text="Translator.translateRef(user)"/>
        </q-item>
        <q-separator/>
      </template>
    </div>
  </div>
</template>
